<template>
  <main-layout>
    <div class="page-container">
      <h1 class="heading-1">Invoicing</h1>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout"

export default {
  name: "InvoicingPage",
  created() {
    this.$emit("update:layout", MainLayout)
  },
  components: {
    MainLayout
  }
}
</script>

<style lang="scss" scoped>

</style>
